import type { Comic } from "@/types/comic";

export const comics: Comic[] = [
  {
    id: "1",
    title: "烈火战魂",
    author: "陈烽",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20fierce%20young%20warrior%20holding%20a%20glowing%20flame%20sword%2C%20dynamic%20action%20pose%2C%20vibrant%20orange%20and%20red%20palette%2C%20clean%20simple%20gradient%20background%2C%20high%20detail%20digital%20art%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    genres: ["热血", "奇幻"],
    status: "连载",
    description:
      "少年焰燚体内沉睡着一枚远古火种，为了守护家园，他踏上寻找火种真相的旅途。烈焰焚尽黑暗，热血点燃青春，一场关于信念与牺牲的成长史诗就此展开。",
    rating: 9.6,
    favorites: 128340,
    updateTime: "2026-10-11",
    chapters: [
      { id: "1", title: "第1话 火种觉醒", updateTime: "2026-09-02" },
      { id: "2", title: "第2话 试炼之塔", updateTime: "2026-09-09" },
      { id: "3", title: "第3话 炎之契约", updateTime: "2026-09-16" },
      { id: "4", title: "第4话 同门对决", updateTime: "2026-09-23" },
      { id: "5", title: "第5话 暗流涌动", updateTime: "2026-09-30" },
      { id: "6", title: "第6话 血脉真相", updateTime: "2026-10-05" },
      { id: "7", title: "第7话 赤炎焚天", updateTime: "2026-10-09" },
      { id: "8", title: "第8话 新的敌人", updateTime: "2026-10-11" },
    ],
  },
  {
    id: "2",
    title: "星海彼岸",
    author: "林晨曦",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20young%20female%20space%20explorer%20floating%20among%20glowing%20stars%2C%20sleek%20futuristic%20suit%2C%20deep%20blue%20and%20teal%20palette%2C%20clean%20simple%20gradient%20background%2C%20high%20detail%20digital%20art%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    genres: ["科幻", "奇幻"],
    status: "连载",
    description:
      "人类首次跃迁失败的百年后，少女领航员星辰独自驾驶残破飞船，穿过未知星域寻找传说中的彼岸。孤独的旅途上，她遇见了不属于任何星图的文明回声。",
    rating: 9.3,
    favorites: 87620,
    updateTime: "2026-10-10",
    chapters: [
      { id: "1", title: "第1话 失联信号", updateTime: "2026-08-28" },
      { id: "2", title: "第2话 星图之外", updateTime: "2026-09-05" },
      { id: "3", title: "第3话 沉睡舰船", updateTime: "2026-09-14" },
      { id: "4", title: "第4话 回声文明", updateTime: "2026-09-22" },
      { id: "5", title: "第5话 引力陷阱", updateTime: "2026-09-30" },
      { id: "6", title: "第6话 彼岸坐标", updateTime: "2026-10-06" },
      { id: "7", title: "第7话 抉择之刻", updateTime: "2026-10-10" },
    ],
  },
  {
    id: "3",
    title: "都市医仙",
    author: "顾清欢",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20calm%20young%20male%20doctor%20with%20faint%20green%20healing%20aura%2C%20modern%20city%20backdrop%2C%20mint%20and%20dark%20teal%20palette%2C%20clean%20simple%20gradient%20background%2C%20high%20detail%20digital%20art%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    genres: ["都市", "奇幻"],
    status: "连载",
    description:
      "普通实习生叶归舟意外继承千年医仙传承，一枚银针可活死人、可断生死。当医术交锋资本，他在这座钢铁森林里，走出了一条逆袭通天路。",
    rating: 9.1,
    favorites: 96450,
    updateTime: "2026-10-11",
    chapters: [
      { id: "1", title: "第1话 觉醒传承", updateTime: "2026-08-20" },
      { id: "2", title: "第2话 银针救人", updateTime: "2026-08-29" },
      { id: "3", title: "第3话 医闹风波", updateTime: "2026-09-08" },
      { id: "4", title: "第4话 隐世高人", updateTime: "2026-09-18" },
      { id: "5", title: "第5话 药王之争", updateTime: "2026-09-27" },
      { id: "6", title: "第6话 古方重现", updateTime: "2026-10-04" },
      { id: "7", title: "第7话 生死一线", updateTime: "2026-10-08" },
      { id: "8", title: "第8话 名动全城", updateTime: "2026-10-11" },
    ],
  },
  {
    id: "4",
    title: "我的青春恋爱日记",
    author: "苏小暖",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20sweet%20high%20school%20couple%20under%20cherry%20blossoms%2C%20soft%20pink%20and%20warm%20cream%20palette%2C%20clean%20simple%20gradient%20background%2C%20romantic%20shojo%20style%2C%20high%20detail%20digital%20art%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    genres: ["恋爱", "校园"],
    status: "完结",
    description:
      "一封写错了名字的情书，让平凡少女林小满和全校第一的江辰有了交集。从校园到毕业，那些藏在日记里的心事，最终都开成了春天最温柔的花。",
    rating: 9.4,
    favorites: 152780,
    updateTime: "2026-07-18",
    chapters: [
      { id: "1", title: "第1话 写错的名字", updateTime: "2026-03-06" },
      { id: "2", title: "第2话 同桌距离", updateTime: "2026-03-20" },
      { id: "3", title: "第3话 文化祭", updateTime: "2026-04-04" },
      { id: "4", title: "第4话 雨中的伞", updateTime: "2026-04-19" },
      { id: "5", title: "第5话 偷偷喜欢", updateTime: "2026-05-08" },
      { id: "6", title: "第6话 毕业钟声", updateTime: "2026-06-12" },
      { id: "7", title: "第7话 花开彼岸", updateTime: "2026-07-18" },
    ],
  },
  {
    id: "5",
    title: "迷雾侦探社",
    author: "江夜白",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20noir%20detective%20in%20a%20trench%20coat%20with%20a%20magnifying%20glass%20in%20foggy%20alley%2C%20dark%20grey%20and%20muted%20blue%20palette%2C%20clean%20simple%20gradient%20background%2C%20suspense%20style%2C%20high%20detail%20digital%20art%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    genres: ["悬疑"],
    status: "连载",
    description:
      "只要支付得起代价，迷雾侦探社就能解开任何谜题。侦探墨白与神秘助手接下一桩无人敢查的旧案，真相背后，是比迷雾更深的人心。",
    rating: 9.5,
    favorites: 73410,
    updateTime: "2026-10-09",
    chapters: [
      { id: "1", title: "第1话 无名委托", updateTime: "2026-08-14" },
      { id: "2", title: "第2话 消失的房客", updateTime: "2026-08-26" },
      { id: "3", title: "第3话 第二封信", updateTime: "2026-09-07" },
      { id: "4", title: "第4话 密室之门", updateTime: "2026-09-19" },
      { id: "5", title: "第5话 证人谎言", updateTime: "2026-09-29" },
      { id: "6", title: "第6话 雨夜追踪", updateTime: "2026-10-04" },
      { id: "7", title: "第7话 真相的代价", updateTime: "2026-10-09" },
    ],
  },
  {
    id: "6",
    title: "剑破九霄",
    author: "墨青衣",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20young%20swordsman%20in%20flowing%20robes%20raising%20a%20glowing%20sword%20toward%20a%20mystic%20sky%2C%20jade%20green%20and%20gold%20palette%2C%20clean%20simple%20gradient%20background%2C%20xianxia%20cultivation%20style%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    genres: ["热血", "奇幻", "历史"],
    status: "连载",
    description:
      "一剑破万法，一剑斩苍穹。落魄少年陆九霄被逐出宗门，却在绝境中悟得无上剑意。当他重回九霄之巅，整个修仙界都要为昔日的轻视付出代价。",
    rating: 9.2,
    favorites: 110560,
    updateTime: "2026-10-11",
    chapters: [
      { id: "1", title: "第1话 逐出师门", updateTime: "2026-08-18" },
      { id: "2", title: "第2话 剑意初成", updateTime: "2026-08-30" },
      { id: "3", title: "第3话 荒山试剑", updateTime: "2026-09-11" },
      { id: "4", title: "第4话 故人重逢", updateTime: "2026-09-21" },
      { id: "5", title: "第5话 血战长老", updateTime: "2026-09-30" },
      { id: "6", title: "第6话 九霄剑冢", updateTime: "2026-10-06" },
      { id: "7", title: "第7话 剑破苍穹", updateTime: "2026-10-11" },
    ],
  },
  {
    id: "7",
    title: "机械纪元",
    author: "罗辑",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20young%20mecha%20pilot%20in%20a%20cockpit%20facing%20a%20giant%20robot%20armor%2C%20steel%20grey%20and%20electric%20blue%20palette%2C%20clean%20simple%20gradient%20background%2C%20sci%20fi%20mecha%20style%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    genres: ["科幻", "热血"],
    status: "连载",
    description:
      "当机械觉醒，人类成为被圈养的燃料。少年技师zero驾驶着第一台拥有自我意识的机甲，在废墟之上点燃反抗的火种，为人类的自由而战。",
    rating: 8.9,
    favorites: 68230,
    updateTime: "2026-10-08",
    chapters: [
      { id: "1", title: "第1话 觉醒之时", updateTime: "2026-08-22" },
      { id: "2", title: "第2话 钢铁兄弟", updateTime: "2026-09-03" },
      { id: "3", title: "第3话 第一次战斗", updateTime: "2026-09-15" },
      { id: "4", title: "第4话 记忆芯片", updateTime: "2026-09-25" },
      { id: "5", title: "第5话 反抗宣言", updateTime: "2026-10-02" },
      { id: "6", title: "第6话 废墟之约", updateTime: "2026-10-08" },
    ],
  },
  {
    id: "8",
    title: "花间令",
    author: "沈妤",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20an%20elegant%20ancient%20chinese%20couple%20in%20hanfu%20surrounded%20by%20peony%20flowers%2C%20rose%20pink%20and%20gold%20palette%2C%20clean%20simple%20gradient%20background%2C%20historical%20romance%20style%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    genres: ["恋爱", "历史"],
    status: "完结",
    description:
      "大婚之夜，她替姐姐嫁入了仇家。绣坊少主与冷面王爷各怀心事，一纸花间令将两人命运缠绕。权谋与深情交织，谁先动了真心，谁就满盘皆输。",
    rating: 9.0,
    favorites: 91870,
    updateTime: "2026-06-30",
    chapters: [
      { id: "1", title: "第1话 替嫁", updateTime: "2026-02-20" },
      { id: "2", title: "第2话 绣坊令", updateTime: "2026-03-10" },
      { id: "3", title: "第3话 一场赌局", updateTime: "2026-04-02" },
      { id: "4", title: "第4话 暗香浮动", updateTime: "2026-04-26" },
      { id: "5", title: "第5话 宫宴风波", updateTime: "2026-05-18" },
      { id: "6", title: "第6话 花间之约", updateTime: "2026-06-30" },
    ],
  },
  {
    id: "9",
    title: "深夜食堂物语",
    author: "田叔",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20cozy%20night%20street%20food%20stall%20with%20warm%20lantern%20light%20and%20steaming%20bowls%2C%20warm%20amber%20and%20brown%20palette%2C%20clean%20simple%20gradient%20background%2C%20slice%20of%20life%20style%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    genres: ["都市", "搞笑"],
    status: "连载",
    description:
      "城市打烊之后，巷口的小摊才刚亮起灯。老板一言不发，却用一碗碗热腾腾的宵夜，接住了每个深夜失眠的人。食物有温度，故事有回甘。",
    rating: 8.8,
    favorites: 54120,
    updateTime: "2026-10-07",
    chapters: [
      { id: "1", title: "第1话 加班的人", updateTime: "2026-08-11" },
      { id: "2", title: "第2话 一碗阳春面", updateTime: "2026-08-24" },
      { id: "3", title: "第3话 生日的蛋", updateTime: "2026-09-06" },
      { id: "4", title: "第4话 老主顾", updateTime: "2026-09-17" },
      { id: "5", title: "第5话 相亲实录", updateTime: "2026-09-28" },
      { id: "6", title: "第6话 打烊以后", updateTime: "2026-10-07" },
    ],
  },
  {
    id: "10",
    title: "幽冥古卷",
    author: "白无常",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20an%20eerie%20ancient%20scroll%20glowing%20with%20ghostly%20light%20and%20faint%20spirits%2C%20dark%20purple%20and%20sickly%20green%20palette%2C%20clean%20simple%20gradient%20background%2C%20horror%20style%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    genres: ["恐怖", "悬疑"],
    status: "连载",
    description:
      "一本用人皮装订的古卷，每翻开一页，就会少一个人。民俗学者程野为了找回失踪的妹妹，不得不亲手解开古卷上被诅咒的封印。",
    rating: 8.7,
    favorites: 46230,
    updateTime: "2026-10-05",
    chapters: [
      { id: "1", title: "第1话 第一卷", updateTime: "2026-08-09" },
      { id: "2", title: "第2话 第一个名字", updateTime: "2026-08-21" },
      { id: "3", title: "第3话 无灯的房间", updateTime: "2026-09-02" },
      { id: "4", title: "第4话 镜中之人", updateTime: "2026-09-14" },
      { id: "5", title: "第5话 妹妹的信", updateTime: "2026-09-26" },
      { id: "6", title: "第6话 封印松动", updateTime: "2026-10-05" },
    ],
  },
  {
    id: "11",
    title: "篮下之光",
    author: "高飞翔",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20high%20school%20basketball%20player%20jumping%20for%20a%20dunk%2C%20energetic%20pose%2C%20fiery%20orange%20and%20white%20palette%2C%20clean%20simple%20gradient%20background%2C%20sports%20shonen%20style%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    genres: ["热血", "校园"],
    status: "连载",
    description:
      "身高一米七的替补球员林峰，靠着永不疲倦的跑动和一颗大心脏，从球场最角落一步步打到聚光灯下。冠军只有一个，但热爱没有上限。",
    rating: 9.0,
    favorites: 79450,
    updateTime: "2026-10-11",
    chapters: [
      { id: "1", title: "第1话 板凳席", updateTime: "2026-08-16" },
      { id: "2", title: "第2话 第一次首发", updateTime: "2026-08-28" },
      { id: "3", title: "第3话 强敌来袭", updateTime: "2026-09-09" },
      { id: "4", title: "第4话 逆风翻盘", updateTime: "2026-09-20" },
      { id: "5", title: "第5话 队友", updateTime: "2026-10-01" },
      { id: "6", title: "第6话 篮球场之约", updateTime: "2026-10-07" },
      { id: "7", title: "第7话 决胜时刻", updateTime: "2026-10-11" },
    ],
  },
  {
    id: "12",
    title: "幻梦仙途",
    author: "云中鹤",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20celestial%20immortal%20maiden%20standing%20on%20a%20floating%20mountain%20peak%20among%20clouds%2C%20ethereal%20lavender%20and%20cyan%20palette%2C%20clean%20simple%20gradient%20background%2C%20xianxia%20fantasy%20style%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    genres: ["奇幻", "历史"],
    status: "完结",
    description:
      "她是被仙门遗弃的杂灵根，却在梦中窥见了三千世界的尽头。当幻梦与现实重叠，她终于明白，所谓仙途，不过是一场与自己的漫长和解。",
    rating: 8.9,
    favorites: 63980,
    updateTime: "2026-05-22",
    chapters: [
      { id: "1", title: "第1话 杂灵根", updateTime: "2026-01-15" },
      { id: "2", title: "第2话 入梦", updateTime: "2026-02-08" },
      { id: "3", title: "第3话 云海之上", updateTime: "2026-03-05" },
      { id: "4", title: "第4话 三千世界", updateTime: "2026-04-01" },
      { id: "5", title: "第5话 幻梦终章", updateTime: "2026-05-22" },
    ],
  },
  {
    id: "13",
    title: "次元咖啡馆",
    author: "阿糖",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20cheerful%20cafe%20girls%20in%20cute%20uniforms%20holding%20colorful%20drinks%2C%20pastel%20pink%20and%20mint%20palette%2C%20clean%20simple%20gradient%20background%2C%20comedy%20slice%20of%20life%20style%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-13&orientation=portrait",
    genres: ["搞笑", "都市"],
    status: "连载",
    description:
      "这家咖啡馆有个奇怪的规矩：只要点单时说出一句只有你自己懂的台词，店员就会为你端上一杯来自另一个次元的特调。荒唐又治愈的日常，就此开张。",
    rating: 8.6,
    favorites: 41230,
    updateTime: "2026-10-06",
    chapters: [
      { id: "1", title: "第1话 开业大吉", updateTime: "2026-08-13" },
      { id: "2", title: "第2话 神秘点单", updateTime: "2026-08-26" },
      { id: "3", title: "第3话 次元特调", updateTime: "2026-09-08" },
      { id: "4", title: "第4话 常客之争", updateTime: "2026-09-19" },
      { id: "5", title: "第5话 深夜开张", updateTime: "2026-09-30" },
      { id: "6", title: "第6话 打烊风波", updateTime: "2026-10-06" },
    ],
  },
  {
    id: "14",
    title: "重生之商海沉浮",
    author: "陆沉",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20confident%20young%20businessman%20in%20a%20suit%20before%20a%20city%20skyline%20at%20dusk%2C%20charcoal%20grey%20and%20gold%20palette%2C%20clean%20simple%20gradient%20background%2C%20urban%20drama%20style%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-14&orientation=portrait",
    genres: ["都市", "奇幻"],
    status: "连载",
    description:
      "带着未来十年的记忆重生回到创业前夜，江远这一次不再重蹈覆辙。资本的棋局、旧日的情谊、未竟的野心，他要在这个时代亲手改写自己的结局。",
    rating: 9.1,
    favorites: 88720,
    updateTime: "2026-10-10",
    chapters: [
      { id: "1", title: "第1话 重生前夜", updateTime: "2026-08-17" },
      { id: "2", title: "第2话 第一桶金", updateTime: "2026-08-29" },
      { id: "3", title: "第3话 旧日对手", updateTime: "2026-09-10" },
      { id: "4", title: "第4话 资本博弈", updateTime: "2026-09-21" },
      { id: "5", title: "第5话 风口之上", updateTime: "2026-10-02" },
      { id: "6", title: "第6话 暗棋浮出", updateTime: "2026-10-10" },
    ],
  },
  {
    id: "15",
    title: "月下红线",
    author: "洛九歌",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20couple%20bound%20by%20a%20glowing%20red%20thread%20under%20a%20huge%20full%20moon%2C%20deep%20crimson%20and%20midnight%20blue%20palette%2C%20clean%20simple%20gradient%20background%2C%20romantic%20fantasy%20style%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-15&orientation=portrait",
    genres: ["恋爱", "奇幻"],
    status: "连载",
    description:
      "月老庙里的一根红线，让两个本不该相遇的人被命运拴在一起。可红线也会断，会乱，会绕。当她终于看清自己心里的那条线，才发现牵住的从来不是命运。",
    rating: 9.2,
    favorites: 84510,
    updateTime: "2026-10-09",
    chapters: [
      { id: "1", title: "第1话 月老庙", updateTime: "2026-08-19" },
      { id: "2", title: "第2话 红线结", updateTime: "2026-08-31" },
      { id: "3", title: "第3话 命定之人", updateTime: "2026-09-12" },
      { id: "4", title: "第4话 线乱如麻", updateTime: "2026-09-23" },
      { id: "5", title: "第5话 断线之痛", updateTime: "2026-10-03" },
      { id: "6", title: "第6话 心之所向", updateTime: "2026-10-09" },
    ],
  },
  {
    id: "16",
    title: "末日回响",
    author: "冯远",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20lone%20survivor%20standing%20in%20a%20ruined%20desolate%20city%20under%20a%20blood%20red%20sky%2C%20ash%20grey%20and%20ember%20orange%20palette%2C%20clean%20simple%20gradient%20background%2C%20post%20apocalyptic%20style%2C%20vertical%20book%20cover&width=400&height=560&seq=comic-cover-16&orientation=portrait",
    genres: ["科幻", "恐怖"],
    status: "完结",
    description:
      "文明崩塌的第七年，废墟里仍会传来旧世界的广播回响。幸存者阿遥循着断断续续的信号前行，只为找到那个还在广播的人，也找回人类最后的体面。",
    rating: 8.8,
    favorites: 52640,
    updateTime: "2026-04-28",
    chapters: [
      { id: "1", title: "第1话 第七年", updateTime: "2026-01-10" },
      { id: "2", title: "第2话 广播回响", updateTime: "2026-02-02" },
      { id: "3", title: "第3话 废墟同行", updateTime: "2026-02-26" },
      { id: "4", title: "第4话 最后的人", updateTime: "2026-03-22" },
      { id: "5", title: "第5话 回响终章", updateTime: "2026-04-28" },
    ],
  },
];

export const readerPages: string[] = [
  "https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20panel%20page%20showing%20a%20young%20hero%20drawing%20a%20glowing%20sword%20in%20a%20dramatic%20close%20up%2C%20speed%20lines%20and%20screentone%20shading%2C%20clean%20line%20art%2C%20detailed%20manga%20ink%20drawing&width=800&height=1150&seq=reader-page-01&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20panel%20page%20of%20two%20characters%20facing%20off%20in%20a%20wide%20action%20scene%2C%20dynamic%20perspective%20and%20motion%20blur%2C%20screentone%20shading%2C%20clean%20line%20art%2C%20detailed%20manga%20ink%20drawing&width=800&height=1150&seq=reader-page-02&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20panel%20page%20of%20a%20quiet%20emotional%20conversation%20between%20two%20friends%20in%20a%20classroom%2C%20soft%20shading%20and%20speech%20bubbles%2C%20clean%20line%20art%2C%20detailed%20manga%20ink%20drawing&width=800&height=1150&seq=reader-page-03&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20panel%20page%20of%20a%20city%20skyline%20at%20night%20with%20a%20lone%20figure%20on%20a%20rooftop%2C%20moody%20atmosphere%20and%20screentone%20gradients%2C%20clean%20line%20art%2C%20detailed%20manga%20ink%20drawing&width=800&height=1150&seq=reader-page-04&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20panel%20page%20of%20an%20explosive%20battle%20with%20energy%20bursts%20and%20impact%20effects%2C%20high%20contrast%20ink%20shading%2C%20clean%20line%20art%2C%20detailed%20manga%20ink%20drawing&width=800&height=1150&seq=reader-page-05&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20panel%20page%20of%20a%20mysterious%20shadowed%20villain%20revealing%20a%20secret%2C%20dramatic%20lighting%20and%20screentone%2C%20clean%20line%20art%2C%20detailed%20manga%20ink%20drawing&width=800&height=1150&seq=reader-page-06&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20panel%20page%20of%20a%20heroic%20last%20stand%20under%20rain%2C%20intense%20emotion%20and%20rain%20streaks%2C%20screentone%20shading%2C%20clean%20line%20art%2C%20detailed%20manga%20ink%20drawing&width=800&height=1150&seq=reader-page-07&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20panel%20page%20of%20a%20peaceful%20ending%20scene%20with%20a%20sunrise%20and%20two%20characters%20walking%20away%2C%20soft%20gradual%20shading%2C%20clean%20line%20art%2C%20detailed%20manga%20ink%20drawing&width=800&height=1150&seq=reader-page-08&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20panel%20page%20of%20a%20fantasy%20monster%20emerging%20from%20dark%20fog%2C%20detailed%20texture%20and%20screentone%20hatching%2C%20clean%20line%20art%2C%20detailed%20manga%20ink%20drawing&width=800&height=1150&seq=reader-page-09&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Black%20and%20white%20manga%20comic%20panel%20page%20of%20a%20close%20up%20of%20a%20character%20smiling%20with%20tears%2C%20delicate%20emotional%20expression%20and%20soft%20shading%2C%20clean%20line%20art%2C%20detailed%20manga%20ink%20drawing&width=800&height=1150&seq=reader-page-10&orientation=portrait",
];

export const genreList: string[] = [
  "热血",
  "恋爱",
  "奇幻",
  "悬疑",
  "科幻",
  "校园",
  "都市",
  "搞笑",
  "历史",
  "恐怖",
];

export const searchHotWords: string[] = [
  "烈火战魂",
  "剑破九霄",
  "星海彼岸",
  "都市医仙",
  "月下红线",
  "陈烽",
  "苏小暖",
  "迷雾侦探社",
];